import React, { Component } from 'react';
import { Table, Button, Form, Select, Input, Spin, Modal } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getListSettings, updateSettings } from './action';

import './styles.css';

const EditableContext = React.createContext();
const { Option } = Select;

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (e) => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  renderCell = (form) => {
    this.form = form;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(<Input ref={(node) => (this.input = node)} onPressEnter={this.save} onBlur={this.save} />)}
      </Form.Item>
    ) : (
      <div className='editable-cell-value-wrap' style={{ paddingRight: 24 }} onClick={this.toggleEdit}>
        {children}
      </div>
    );
  };

  render() {
    const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } = this.props;
    return (
      <td {...restProps}>
        {editable ? <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer> : children}
      </td>
    );
  }
}

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 2,
      visible: false,
    };
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.props.getListSettings();
  }

  handleSave = (row) => {
    this.props.updateSettings(row);
  };

  /**
   * render View
   * @return {Component}
   */
   render() {
    const { settings } = this.props;
    const { visible } = this.state;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    this.columns = [
      {
        title: 'Key',
        dataIndex: 'keyword',
        width: '25%',
        editable: false,
      },
      {
        title: 'Value',
        dataIndex: 'content',
        width: '20%',
        editable: true,
      }
    ];
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    return (
        <div className='container'>
          <Form.Item>
            <div className='form-table-user'>
              <Table
                rowKey={record => record.id}
                loading={settings?.isLoading ? { indicator: <Spin size='small' /> } : false}
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={settings.listSettings}
                columns={columns}
              />
            </div>
          </Form.Item>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getListSettings: () => dispatch(getListSettings()),
    updateSettings: (params) => dispatch(updateSettings(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Index));